import A1MapViewer from '../api/A1MapViewer'

function App() {
  A1MapViewer.internalInit()

  window.A1MapViewer = A1MapViewer
}

export default App
